import { render } from "./NewVaTestTabPane.vue?vue&type=template&id=22712e4f&scoped=true"
import script from "./NewVaTestTabPane.vue?vue&type=script&lang=js"
export * from "./NewVaTestTabPane.vue?vue&type=script&lang=js"

import "./NewVaTestTabPane.vue?vue&type=style&index=0&id=22712e4f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22712e4f"]])

export default __exports__